import React from "react";
import { Link } from "react-router-dom";
import { useSidebarState } from "@/hooks/useSidebarState";
import { 
  LinksSection, 
  usePlayerLinks, 
  useMainLinks 
} from "./sidebar/PlayerSidebarLinks";
import { ProfileSection } from "./sidebar/PlayerSidebarProfile";
import { SidebarDivider } from "./sidebar/PlayerSidebarDivider";
import { SidebarFooter } from "./sidebar/PlayerSidebarFooter";
import { SidebarToggle } from "./sidebar/PlayerSidebarToggle";
import { SidebarContainer } from "./sidebar/PlayerSidebarContainer";
import logo from "/lovable-uploads/5639bd1d-d899-4190-af54-f5f73944d997.png";

export const PlayerSidebar = () => {
  const { isCollapsed, toggleSidebar } = useSidebarState();
  const playerLinks = usePlayerLinks();
  const mainLinks = useMainLinks();

  return (
    <SidebarContainer isCollapsed={isCollapsed}>
      {/* Logo Section */}
      <div className={`flex items-center justify-center bg-[#181D24] border-b border-[#222A35]/30 relative ${isCollapsed ? 'h-12' : 'h-16'}`}>
        <Link 
          to="/"
          className="cursor-pointer hover:opacity-80 transition-opacity"
          title="Voltar para a página inicial"
        >
          <img 
            src={logo} 
            alt="Arena Pro Player Logo" 
            className={`object-contain transition-all duration-300 ${
              isCollapsed ? 'w-8 h-8' : 'w-12 h-12'
            }`}
          />
        </Link>
        
        {/* Botão toggle posicionado na seção do logo */}
        <button 
          onClick={toggleSidebar}
          className="absolute right-[-12px] top-1/2 transform -translate-y-1/2 bg-[#222A35] border border-[#2D3748] rounded-full w-6 h-6 flex items-center justify-center text-[#00B6F0] z-30"
        >
          {isCollapsed ? (
            <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          ) : (
            <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          )}
        </button>
      </div>

      {/* User Profile */}
      <ProfileSection isCollapsed={isCollapsed} />

      {/* Container scrollável para os links */}
      <div className="flex-1 overflow-y-auto overflow-x-hidden sidebar-scroll">
        {/* Divider */}
        <SidebarDivider isCollapsed={isCollapsed} title="Seu Painel" />

        {/* Player Links */}
        <div className="px-2 mb-4">
          <LinksSection links={playerLinks} isCollapsed={isCollapsed} />
        </div>

        {/* Divider */}
        <SidebarDivider isCollapsed={isCollapsed} title="Navegação" />

        {/* Main Links */}
        <div className="px-2 mb-6">
          <LinksSection links={mainLinks} isCollapsed={isCollapsed} />
        </div>
      </div>

      {/* Footer */}
      <SidebarFooter isCollapsed={isCollapsed} />
    </SidebarContainer>
  );
};

export default PlayerSidebar;
